module.exports = __webpack_public_path__ + "static/media/package-purple.a34b4db0.svg";